"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

const DEFAULT_REDIRECT_GROUP = {
   title: "Try one of these pages",
   links: [
      { href: "/", label: "Go to home page", primary: true },
   ],
};

/**
 * Keeps 404 recovery actions relevant to the section users came from.
 */
function getRedirectGroupFromPathname(pathname) {
   const normalizedPathname = (pathname || "").toLowerCase();

   if (normalizedPathname.startsWith("/quotes")) {
      return {
         title: "Looks like a quote page is missing",
         links: [
            { href: "/quotes/car-insurance-quote", label: "Car insurance quotes", primary: true }
         ],
      };
   }

   if (normalizedPathname.startsWith("/claims")) {
      return {
         title: "Looks like a claim page is missing",
         links: [
            { href: "/claims/accident-management-claim", label: "Accident management claims", primary: true },
         ],
      };
   }

   if (normalizedPathname.startsWith("/blog")) {
      return {
         title: "Looks like a blog page is missing",
         links: [
            { href: "/blog/posts", label: "Read latest blog posts", primary: true },
         ],
      };
   }

   if (normalizedPathname.startsWith("/news")) {
      return {
         title: "Looks like a news page is missing",
         links: [
            { href: "/news", label: "Go to news section", primary: true }
         ],
      };
   }

   if (normalizedPathname.startsWith("/tips")) {
      return {
         title: "Looks like a tips page is missing",
         links: [
            { href: "/tips", label: "Explore all tips", primary: true }
         ],
      };
   }

   if (normalizedPathname.startsWith("/contact") || normalizedPathname.startsWith("/about")) {
      return {
         title: "Looks like an information page is missing",
         links: [
            { href: "/about", label: "About us", primary: true },
         ],
      };
   }

   return DEFAULT_REDIRECT_GROUP;
}

export default function NotFoundRedirectLinks() {
   const currentPathname = usePathname();
   const redirectGroup = getRedirectGroupFromPathname(currentPathname);

   return (
      <>
         <p className="fw-semibold mb-3">{redirectGroup.title}</p>
         <div className="d-flex flex-wrap justify-content-center gap-2 mb-4">
            {redirectGroup.links?.map((linkItem) => (
               <Link
                  key={linkItem.href}
                  href={linkItem.href}
                  className={`btn ${linkItem.primary ? "btn-danger" : "btn-outline-danger"} px-4`}
               >
                  {linkItem.label}
               </Link>
            ))}
         </div>
      </>
   );
}
